import { render } from "./OnboardingSection.vue?vue&type=template&id=d3d27e12"
import script from "./OnboardingSection.vue?vue&type=script&lang=js"
export * from "./OnboardingSection.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./OnboardingSection.vue?vue&type=style&index=0&id=d3d27e12&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__